<template>
    <div id="ContainerCalendarResources">
        <div class="page-height">
            <div class="col-12">
                <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('calendarResources.Edit') }}
                </h4>
                <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('calendarResources.Add') }}
                </h4>
                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <MdLookup
                            v-bind:ModelCode="selectedEmployeeModel.code"
                            v-bind:ModelDescription="selectedEmployeeModel.description"
                            v-bind:Label="$t('calendarResources.AvailEmployees')"
                            v-bind:RefCode="'editableItem.employeeCode'"
                            v-bind:Api="'Employees/LookUp'"
                            v-bind:Fields="availEmployeeFields"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'description'"
                            v-bind:isValid="isEmployeeValid"
                            v-bind:isRequired="true"
                            :InvalidFeedback="textAvailEmployee"
                            :IsDisabled="false"
                            :SearchTitle="$t('calendarResources.AvailEmployees')"
                            :GetValues="onAvailEmployeCodeConditionOk"
                            :SearchFieldCode="'Code'"
                        />
                    </b-col>
                </b-row>
                <!--Employee Options-->
                <MdTitle
                    v-bind:Text="$t('calendarResources.eEmplOpt')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdSelect
                            v-bind:Label="$t('calendarResources.sBillCode')"
                            v-bind:Options="superBillList"
                            v-bind:Model="superBillModel"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Multiple="false"
                            v-bind:UseParamsAux="true"
                            v-bind:AuxParam="{ dbField: 'superBillCode', uiModel: superBillModel }"
                            :Input="handleComboChange"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdRadioGroup
                            v-bind:Label="$t('calendarResources.dBooking')"
                            v-model="editableItem.dblBook"
                            v-bind:Options="doubleBookingList"
                            v-bind:Name="'doubleBooking'"
                        />
                    </b-col>
                </b-row>

                <!--Restricted Users-->
                <ModalTableMultiSelectServer
                    v-bind:Fields="availUserFieldsServer"
                    v-bind:Resource="resourceParameterUsers"
                    @getCodeConditionOK="onCodeConditionAddUsers($event)"
                    @getCodeConditionCancel="onCodeConditionCancelUsers($event)"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    v-bind:TitleWindow="$t('calendarResources.UserSelectDialog.Title')"
                    v-bind:ModalId="modalIdUsers"
                    v-bind:ReturnAll="true"
                ></ModalTableMultiSelectServer>
                <MdTitle
                    v-bind:Text="$t('calendarResources.eRestrictUsers')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />

                <b-row>
                    <b-col class="col-sm-12 col-md-3">  
                        <MdButton
                            v-bind:Label="$t('Shared.Add')"
                            v-bind:ClassProp="
                                'btn btn-primary my-3 btn-block btn-login'
                            "
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-bind:isReadOnly="false"
                            v-on:click="addUsers"
                        >
                        </MdButton>
                    </b-col>
                    <b-col class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="searchUsers"
                                    @keyup.enter="findUsers"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="findUsers">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <MdTablePaginationClient
                            v-bind:fields="availUserFieldsClient"
                            v-bind:items="filteredUserCodes"
                            v-bind:totalRows="totalRowsUsers"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="showMessageIsEmptyUsers"
                            v-bind:currentPage="currentPageUsers"
                            v-bind:perPage="perPageUsers"
                            v-bind:pageOptions="pageOptionsUsers"
                            v-bind:IsItemReceived="true"
                            :onRowSelected="onRowSelectedUsers"
                            :onFiltered="onFilteredUsers"
                            :pageChanged="pageChangedUsers"
                            :perPageFunction="PerPageFunctionUsers"
                            :deleteIconEvent="RemoveUserResult"
                            v-bind:VisibleDeleteIcon="true"
                            :RowClick="RowClick"
                        >
                        </MdTablePaginationClient>
                    </b-col>
                </b-row>
                <!--Appointment limits-->
                <MdTitle
                    v-bind:Text="$t('calendarResources.eApptLimits')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row>
                    <div class="col-sm-12 col-md-3">
                        <MdButton
                            v-bind:Label="$t('Shared.Add')"
                            v-bind:ClassProp="
                                this.isReadOnly || isReadOnlyCalendarResources
                                    ? 'btn btn-primary my-3 btn-block'
                                    : 'btn btn-primary my-3 btn-block btn-login'
                            "
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="callModalTableApptLimits"
                            v-bind:isReadOnly="this.isReadOnly || isReadOnlyCalendarResources"
                        >
                        </MdButton>
                    </div>
                    <div class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="searchApptLimits"
                                    @keyup.enter="findApptLimits"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="findApptLimits"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-row>
                <div class="row">
                    <div class="col-md-12">
                        <MdTablePaginationClient
                            v-bind:fields="fieldsApptLimitsClient"
                            v-bind:items="editableItem.listApptLimits"
                            v-bind:totalRows="totalRowsApptLimits"
                            v-bind:isReadOnly="isReadOnly || isReadOnlyCalendarResources"
                            v-bind:showMessageIsEmpty="showMessageIsEmptyApptLimits"
                            v-bind:currentPage="currentPageApptLimits"
                            v-bind:perPage="perPageApptLimits"
                            v-bind:pageOptions="pageOptionsApptLimits"
                            :onFiltered="onFilteredApptLimits"
                            :pageChanged="pageChangedApptLimits"
                            :RowClick="RowClick"
                            :perPageFunction="perPageFunctionApptLimits"
                            v-bind:VisibleEditIcon="true"
                            :deleteIconEvent="removeApptLimits"
                            :editIconEvent="editApptLimits"
                            v-bind:VisibleDeleteIcon="true"
                            :onRowSelected="onRowSelectedApptLimits"
                        >
                        </MdTablePaginationClient>
                    </div>
                </div>
                <BaseModal
                    v-if="visibleModalApptLimits"
                    ModalId="'ModalIdApptLimits'"
                    :HideModalFun="hideModalApptLimits"
                    :TitleWindow="$tc('calendarResources.eApptLimits')"
                    :width="'700px'"
                    :height="'350px'"
                    :buttons="[
                        { text: 'Cancel', variant: 'secondary', action: 'Close' },
                        { text: 'Ok', variant: 'primary', action: clickOKApptLimits }
                    ]"
                    @Close="closeApptLimits"
                >
                    <form ref="form" @submit.stop.prevent="handleSubmit">
                        <b-row>
                            <b-col lg="6" md="6" sm="12">
                                <MdLookup
                                    v-bind:ModelCode="objApptLimits.appttype"
                                    v-bind:ModelDescription="objApptLimits.apptdescription"
                                    v-bind:RefCode="'ApptLimits'"
                                    v-bind:Api="'AppointmentTypes/LookUp?StopShowing=false'"
                                    v-bind:Fields="fieldsApptLimitsLookUp"
                                    v-bind:Label="$tc('calendarResources.eApptTypes')"
                                    v-bind:FieldCode="'code'"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:isRequired="true"
                                    v-bind:Stacked="false"
                                    :SearchTitle="$tc('calendarResources.eApptTypes')"
                                    :GetValues="onCodeConditionOkApptLimits"
                                    :InvalidFeedback="
                                        $t('ModalcalendarResourcesApptLimits.InvalidApptLimitsCode')
                                    "
                                    :SearchFieldCode="'Code'"
                                />
                            </b-col>
                            <b-col lg="6" md="6" sm="12">
                                <MdEdit
                                    v-bind:Name="'maxPerDay'"
                                    v-bind:Label="$tc('calendarResources.eMaxPerDay')"
                                    v-bind:Placeholder="'1'"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-model.number="objApptLimits.maxperday"
                                    v-bind:isReadOnly="false"
                                />
                            </b-col>
                        </b-row>
                    </form>
                </BaseModal>

                <div class="space-actions"></div>
            </div>

            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btnCalendarResourceslist'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="
                        this.isReadOnlyCalendarResources ? 'primary mx-2' : 'primary btn-login mx-2'
                    "
                    v-on:click="SaveOrEdit"
                    v-bind:isReadOnly="false"
                    v-bind:Name="'btn_save_CalendarResources'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import CalendarResourcesService from '@/services/calendarresources.service';
import SuperBillService from '@/services/superbill.service';
import Utils from '@/common/utils.js';
import { EventBus } from '@/event-bus.js';

let elemSaveBtn = '';

export default {
    name: 'CalendarResources',
    mixins: [ShowMessage, DBFunctions],
    data() {
        return {
            //BaseFields:[],
            textAvailEmployee:this.$t('Msg.RequiredField'),
            isEmployeeValid:true,
            isReadOnly: false,
            isReadOnlyCalendarResources: false,
            superBillList: [],
            superBillModel: { code: null, description: null },
            selectedEmployeeModel: { code: null, description: null },

            editableItem: {
                //General
                employeeCode: null,
                imageIndex: 0,
                isPrivate: 'N',
                userID: '',
                dblBook: 'A',
                superBillCode: '',
                listUsersClient: [],
                listApptLimits: [],
            },
            doubleBookingList: [
                { value: 'A', text: this.$t('calendarResources.dbList.A') },
                { value: 'W', text: this.$t('calendarResources.dbList.W') },
                { value: 'P', text: this.$t('calendarResources.dbList.D') }
            ],
            availEmployeeFields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'hidden'},
                { key: 'description', sortable: true, label: this.$t('Shared.Name') }
            ],
            fieldsApptLimitsClient: [
                { key: 'appttype', sortable: false, label: this.$t('Shared.Code'), class: 'hidden'},
                { key: 'employeecode', sortable: false, label: this.$t('Shared.Code'), class: 'hidden'},
                { key: 'apptdescription', sortable: true, label: this.$t('Shared.Name') },
                { key: 'maxperday', sortable: true, label: this.$t('calendarResources.eMaxPerDay') }
            ],
            fieldsApptLimitsLookUp: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'description', sortable: true, label: this.$t('Shared.Name') },
            ],
            availApptTypeFields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'hidden'},
                { key: 'description', sortable: true, label: this.$t('Shared.Name') }
            ],
            availUserFieldsClient: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Name') }
            ],
            availUserFieldsServer: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'description', sortable: true, label: this.$t('Shared.Name') }
            ],
           
            showMessageIsEmptyApptLimits: true,
            apptLimitsCopy: [],
            objApptLimits: {
                appttype: '',
                employeecode: '',
                apptdescription: '',
                maxperday: 1,
            },
            visibleModalApptLimits: false,
            totalRowsApptLimits: 0,
            currentPageApptLimits: 1,
            perPageApptLimits: 5,
            pageOptionsApptLimits: [5, 10, 15],
            searchApptLimits: '',

            pageOptionsUsers: [5, 10, 15],
            perPageUsers: 10,
            currentPageUsers: 1,
            modalIdUsers: Utils.generateUUID(),
            resourceParameterUsers: '',
            refCodeUsers: 'testOrder',
            searchUsers: "",
            search: {
                users: '',
            },

            pendingChanges: false,
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },
    computed: {
        testOrderAPI() {
            /*if (this.editMode) {
                
            }*/

            return 'Users/LookUp';
        },

        filteredUserCodes() {
            const search = (this.search.users || '').trim().toLowerCase();
            const list = this.editableItem.listUsersClient || [];

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const code = (item.code || '').toLowerCase();
                const description = (item.description || '').toLowerCase();

                return code.includes(search) ||
                    description.includes(search);
            });

        },

        totalRowsUsers() {
            return this.filteredUserCodes.length;
        },

        showMessageIsEmptyUsers() {
            return this.totalRowsUsers === 0;
        },

    },

    methods: {
        //Users
        onRowSelectedUsers () { },

        onCodeConditionCancelUsers() {
            this.resourceParameterUsers = '';
        },

        onCodeConditionAddUsers(results) {
            this.$bvModal.hide(this.modalIdUsers);
            this.resourceParameterUsers = '';

            if (!Array.isArray(results) || results.length === 0) {
                return;
            }

            let hasNewItems = false;

            results.forEach(result => {
                if (!result || !result.code) {
                    return;
                }

                const data = {
                    code: result.code.trim(),
                    description: result.description.trim(),
                };

                const indexOf = this.editableItem.listUsersClient.findIndex(test => test.code === data.code);

                if (indexOf === -1) {
                    this.editableItem.listUsersClient.push(data);
                    hasNewItems = true;
                }
            });

            if (hasNewItems) {
                this.editableItem.listUsersClient.sort((a, b) => {
                    const x = a.description.toLowerCase();
                    const y = b.description.toLowerCase();
                    return x < y ? -1 : x > y ? 1 : 0;
                });
                this.pendingChanges = true;
                this.checkUserAction();
            }
        },

        onFilteredUsers (filteredItems){
            this.totalRowsUsers = filteredItems.length;
            this.currentPageUsers = 1;
        },

        findUsers(){
            this.search.users = this.searchUsers;
            this.currentPage = 1;
        },
        PerPageFunctionUsers (perpage){
            this.perPageUsers = perpage;
            if (this.currentPageUsers > (this.totalRowsUsers / this.perPageUsers)) {
                this.currentPageUsers = 1;
            }
        },

        addUsers() {
            this.resourceParameterUsers = '/' + this.testOrderAPI;
            this.modelFilter = {
                code: 1,
                description: this.$t('TestOrder.TestSelectDialog.TestPanels'),
                resource: this.testOrderAPI
            };

            this.$bvModal.show(this.modalIdUsers);
        },

        RemoveUserResult(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('Shared.PriorAuthorization'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.editableItem.listUsersClient.findIndex(test => test.code === row.code);

                        if (indexOf !== -1) {
                            this.editableItem.listUsersClient.splice(indexOf, 1);
                            this.pendingChanges = true;
                            //this.totalRowsUsers = this.editableItem.listUsersClient.length;
                            this.checkUserAction();
                        }
                    }
                });
        },

        pageChangedUsers(page) {
            this.currentPageUsers = page;
        },


        //ApptLIMITS
        checkFormValidity() {
            return true;
        },

        handleSubmit() {
            if (!this.checkFormValidity()) {
                return;
            }
            this.emitEventOK();
        },

        emitEventOK() {
            const send = {};
            const {
                modeEdit,
                employeecode,
                apptdescription,
                maxperday,
                appttype
            } = this.objApptLimits;

            if (employeecode) send.employeecode = employeecode;
            if (appttype) send.appttype = appttype;
            if (apptdescription) send.apptdescription = apptdescription;
            if (maxperday) send.maxperday = maxperday;
            
            send.editMode = modeEdit;

            this.OnReturnDataApptLimits(send);

            this.resetApptLimitsObject();
            this.visibleModalApptLimits = false;
        },

        isApptLimitsExists(arr, code) {
            return arr.some(item => item.appttype === code);
        },

        UpdateApptLimitsInList(data) {
            const findAndUpdate = (arr, appttype, updatedData) => {
                const index = arr.findIndex(item => item.appttype === appttype);
                if (index !== -1) {
                    //arr[index] = { ...arr[index], ...updatedData };
                    this.$set(arr, index, updatedData);
                    return true;
                }
                return false;
            };

            const updatedFields = {
                employeecode: data.employeecode,
                appttype: data.appttype,
                maxperday: data.maxperday,
                apptdescription: data.apptdescription
            };

            const updatedMain = findAndUpdate(this.editableItem.listApptLimits, data.appttype, updatedFields);
            const updatedCopy = findAndUpdate(this.apptLimitsCopy, data.appttype, updatedFields);

            if (updatedMain) {
                this.editableItem.listApptLimits = [...this.editableItem.listApptLimits];
            }

            if (updatedCopy) {
                this.apptLimitsCopy = [...this.apptLimitsCopy];
            }

            this.$forceUpdate();
        },

        OnReturnDataApptLimits(data) {

            this.checkUserAction();

            if (data.editMode) {
                this.UpdateApptLimitsInList(data);
            } else {
                const existsInMain = this.isApptLimitsExists(
                    this.editableItem.listApptLimits,
                    data.appttype
                );
                const existsInCopy = this.isApptLimitsExists(
                    this.apptLimitsCopy,
                    data.appttype
                );

                const newApptLimits = this.createApptLimitsObject(data);

                if (!existsInMain) {
                    this.editableItem.listApptLimits.push({ ...newApptLimits });
                }
                if (!existsInCopy) {
                    this.apptLimitsCopy.push({ ...newApptLimits });
                }
            }

            this.totalRowsApptLimits = this.editableItem.listApptLimits.length;
            this.showMessageIsEmptyApptLimits = this.editableItem.listApptLimits.length === 0;

            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },

        createApptLimitsObject(data) {
            return {
                employeecode: data.employeecode,
                appttype: data.appttype,
                apptdescription: data.apptdescription,
                maxperday: data.maxperday,
            };
        },

        resetApptLimitsObject() {
            this.objApptLimits.employeecode = '';
            this.objApptLimits.apptdescription = '';
            this.objApptLimits.maxperday = 1;
            this.objApptLimits.modeEdit = false;
        },

        RowClick() {},
        onFilteredApptLimits() {},
        onRowSelectedApptLimits() {},

        onCodeConditionOkApptLimits(result) {
            if (result) {
                this.objApptLimits.appttype = result.code;
                this.objApptLimits.apptdescription = result.description;
            }
        },

        perPageFunctionApptLimits(perpage) {
            this.perPageApptLimits = perpage;
            this.currentPageApptLimits = 1;
        },

        pageChangedApptLimits(page) {
            this.currentPageApptLimits = page;
        },

        editApptLimits(row) {
            /*this.objApptLimits.employeecode = row.employeecode;
            this.objApptLimits.apptdescription = row.apptdescription;
            this.objApptLimits.maxperday = row.maxperday;*/

            this.objApptLimits = {... row, modeEdit: true};
            this.visibleModalApptLimits = true;
        },

        removeApptLimits(e) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('calendarResources.eApptLimits'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        let index = this.editableItem.listApptLimits.findIndex(item => item.code === e.code);
                        if (~index) {
                            this.editableItem.listApptLimits.splice(index, 1);
                            this.pendingChanges = true;
                            this.totalRowsApptLimits = this.editableItem.listApptLimits.length;
                        }

                        const idxCopy = this.apptLimitsCopy.findIndex(item => item.code === e.code);
                        if (~idxCopy) {
                            this.apptLimitsCopy.splice(idxCopy, 1);
                        }
                    }
                });
        },

        callModalTableApptLimits() {
            this.visibleModalApptLimits = true;
        },

        closeApptLimits() {
            this.visibleModalApptLimits = false;
        },

        hideModalApptLimits() {
            this.visibleModalApptLimits = false;
        },

        clickOKApptLimits(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },

        findApptLimits() {
            this.editableItem.listApptLimits = this.apptLimitsCopy;
            var arr = this.editableItem.listApptLimits;
            var temp = [];
            if (this.searchApptLimits) {
                arr.forEach(element => {
                    if (
                        (element.description && 
                            element.description
                                .toUpperCase()
                                .includes(this.searchApptLimits.toUpperCase())) ||
                        (element.code &&
                            element.code
                                .toUpperCase()
                                .includes(this.searchApptLimits.toUpperCase()))
                       
                    ) {
                        temp.push(element);
                    }
                });
            } else {
                temp = this.apptLimitsCopy;
            }

            this.editableItem.listApptLimits = temp;
            this.totalRowsApptLimits = this.editableItem.listApptLimits.length;
        },


        //Select SuperBill
        handleComboChange(selectedOption, params) {
            const codeValue = (selectedOption && selectedOption.code) ? selectedOption.code : null;
            const descValue = (selectedOption && selectedOption.description) ? selectedOption.description : codeValue;

            this.editableItem[params.dbField] = codeValue;

            this.$set(params.uiModel, 'code', codeValue);
            this.$set(params.uiModel, 'description', descValue);
        },

        //LookUp Available Employees
        onAvailEmployeCodeConditionOk (selectedRow) {
            if (selectedRow) {
                this.selectedEmployeeModel.code = selectedRow.code;
                this.selectedEmployeeModel.descrption = selectedRow.description;

                this.editableItem.employeeCode = selectedRow.code;
                
                this.isEmployeeValid = true;
            }
        },

        getLookupSuperBills() {
            this.superBillList = [];

            return SuperBillService.getSuperBillLookup()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        response.data.forEach(element => {
                            const templateObject = {
                                code: element.code ? element.code.trim() : '',
                                description: element.description
                            };

                            this.superBillList.push(templateObject);

                        });
                    }
                });
        },

        syncComboModel(comboModel, dataNode) {
            if (dataNode) {
                this.$set(comboModel, 'code', dataNode.code);
                this.$set(comboModel, 'description', dataNode.description);
            } else {
                this.$set(comboModel, 'code', null);
                this.$set(comboModel, 'description', null);
            }
        },

        DiscardChanges() {
            this.checkExistFavorite('/app/calendarresources');
            this.$router.push({ name: 'calendarresourcesList' });
        },

        IsNullOrEmpty(value) {
            return value === null || value === undefined || value.trim() === '';
        },

        validate_required() {

            this.isEmployeeValid = this.editableItem.employeeCode ? true : false;
            return this.isEmployeeValid;
        },

        DoAction(params) {
            !this.$attrs.editMode ? this.AddCalendarResources(params) : this.EditCalendarResources(params);
        },

        SaveOrEdit() {
            if (this.validate_required()) {
                const updatePayload = JSON.parse(JSON.stringify(this.editableItem));

                //Change List of AvailableEmployees to Comma Separated String
                if (Array.isArray(this.editableItem.listUsersClient) && this.editableItem.listUsersClient.length > 0) {
                    updatePayload.isPrivate = 'Y';
                    updatePayload.userID = this.editableItem.listUsersClient
                        .map(user => user.code)
                        .filter(code => code)
                        .join(',');
                }

                this.DoAction(updatePayload);
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        AddCalendarResources(params) {
            CalendarResourcesService.Add(params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EditCalendarResources(params) {
            CalendarResourcesService.Update(this.editableItem.employeeCode,params)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getCalendarResources() {
            if (this.$attrs.editMode) {
                this.$emit('load', true);
                CalendarResourcesService.Get(this.$route.params.id)
                .then(settingsResponse => {
                    if (settingsResponse.status == '200' && settingsResponse.data) {
                        const backendData = settingsResponse.data;
                        const editableItems = this.editableItem;

                        this.editableItem = Object.keys(editableItems).reduce((mapObject, keyObj) => {
                            const backEndKey = Object.keys(backendData).find(
                                key => key.toLowerCase() === keyObj.toLowerCase()
                            );

                            mapObject[keyObj] = backEndKey !== undefined 
                                ? backendData[backEndKey] 
                                : editableItems[keyObj];

                            return mapObject;
                        }, {});

                        this.selectedEmployeeModel.code = settingsResponse.data.employeecode;
                        this.selectedEmployeeModel.description = settingsResponse.data.employeename;

                        let dataCreate = this.superBillList.find(
                            element => element.code == this.editableItem.superBillCode
                        );
                        this.syncComboModel(this.superBillModel, dataCreate);

                    }
                })
                .catch(error => {
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                });
            }
        },
        
        //Components specific methods
        checkUserAction () {

        },

        loadInitialData () {
            Promise.all([this.getLookupSuperBills()])
                .then(() => {
                    this.getCalendarResources();
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },
    },

    created() {
        this.loadInitialData();
    
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getCalendarResources();
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_CalendarResources');
                elemSaveBtn.setAttribute('disabled', '');
                elemSaveBtn.removeAttribute('disabled');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        /*
            beforeDestroy() {
                EventBus.$off('onChanged');
            },
        */
    },

    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('CalendarResources.cResources'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },
};
</script>
